import CloseIcon from '@mui/icons-material/Close';
import DeleteIcon from '@mui/icons-material/Delete';
import EditIcon from '@mui/icons-material/Edit';
import VisibilityIcon from '@mui/icons-material/Visibility';
import { Backdrop, Box, Button, CircularProgress, Grid, Typography, TextField } from '@mui/material';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import * as Yup from "yup";
import { useFormik } from "formik";
import DialogTitle from '@mui/material/DialogTitle';
import IconButton from '@mui/material/IconButton';
import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import 'react-toastify/dist/ReactToastify.css';
import CheckPermissions from '../../../authorization/authorization';
import BasicTable from '../../../components/basicTable/basicTable';
import { cfpBaseUrl } from '../../../network/urls';
import { companyShortName, convertDatewithTime } from '../../../services/Functions';
import { tableStyle } from '../../../style/common';
import '../OrganizationManagement.scss';
import SearchIcon from '@mui/icons-material/Search';
import EditNoteIcon from '@mui/icons-material/EditNote';
import { Snackbar, Alert } from '@mui/material';
import Error from '../../../components/error/error';
export default function DivisionManagementTable(props) {
    //#region 
    const [divisionsToDataGrid, setDivisionsToDataGrid] = useState([]);
    const [open, setOpen] = useState(false);
    const [open2, setopen2] = useState(false);
    const [dialogRowData, setDialogRowData] = React.useState({});
    const [dltDivision, setDltDivision] = useState()
    const [tableDivision, setTableDivision] = useState([]);
    const [viewBackdrop, setViewBackdrop] = useState(false);
    const [filteredData, setFilteredData] = useState([]);
    const [searchQuery, setSearchQuery] = useState("");
    const [selectedUserId, setSelectedUserId] = useState(null);
    const [showChangePasswordPopup, setShowChangePasswordPopup] = useState(false);
    const [showSuccessSnackbar, setShowSuccessSnackbar] = useState(false);
    const [apiError, setApiError] = useState('')
    const Navigate = useNavigate();
    const errorCloses = () => {
        setApiError("")
    };
    const { token, code: userOfficeCode, permissions } = useSelector((state) => state.auth)

    //#endregion
    useEffect(() => {
        apiToDataGridConversion()
    }, [tableDivision]);

    useEffect(() => {
        const callAllDivisionsAPI = async () => {
            setViewBackdrop(true)
            // const formdata = new FormData();

            // if (userOfficeCode == 10) {
            //     formdata.append("circleCode", '');
            // } else {
            //     formdata.append("circleCode", parseInt(userOfficeCode.toString().slice(0, 2)));
            // }

            // const myHeaders = new Headers();
            // myHeaders.append("Authorization", token);

            // const requestOptions = {
            //     method: "POST",
            //     body: formdata,
            //     headers: myHeaders,
            //     redirect: "follow"
            // };
            const myHeaders = new Headers();
            myHeaders.append("Authorization", token);
            myHeaders.append("Content-Type", "application/json");

            const raw = JSON.stringify({
                "circleCode": userOfficeCode == 10 ? userOfficeCode : parseInt(userOfficeCode.toString().slice(0, 3)),
                "pageNumber": 1,
                "pageSize": 9999
            });

            const requestOptions = {
                method: "POST",
                headers: myHeaders,
                body: raw,
                redirect: "follow"
            };

            await fetch(cfpBaseUrl + "customerFaciliationPortal/getDivisionDetails", requestOptions)
                .then((response) => response.json())
                .then((result) => {
                    if (result.status === "200") {
                        setTableDivision(result.data);
                    } else if (result.status === "401" && result.message === "Session has been expired, Sign in again.") {
                        Navigate('/')
                    }
                })
                .catch((error) => console.error(error));
            setViewBackdrop(false)
        }
        callAllDivisionsAPI()
    }, [])
    const initialValues = {
        iv_divBankName: '',
        iv_divisionERPCode: '',
        iv_divCapitalCostAccountNo: '',
        iv_divSecurityAccountNo: '',
        iv_remarks: '',
    }
    const bankdetailsFormik = useFormik({
        initialValues,
        validationSchema: Yup.object({
            iv_divBankName: Yup.string()
                .max(100, 'Bank name cannot exceed 100 characters.')
                .min(10, 'Bank name must be at least 10 characters long.')
                .required('Bank name is required.'),

            iv_divisionERPCode: Yup.string()
                .required('ERP code is required.'),

            iv_divCapitalCostAccountNo: Yup.string()
                .min(10, 'Capital cost account no. must be at least 10 characters long.')
                .required('Capital cost account no. is required.'),

            iv_divSecurityAccountNo: Yup.string()
                .min(10, 'Security account no. must be at least 10 characters long.')
                .required('Security account no. is required.'),

            iv_remarks: Yup.string()
                .max(100, 'Remarks cannot exceed 100 characters.')
                .required('Remarks are required.')
        }),

        onSubmit: async (values, { resetForm }) => {
            console.log(values, "consolling values")
            // setViewBackdrop(true);
            // const myHeaders = new Headers();
            // myHeaders.append("Authorization", token);
            // myHeaders.append("Content-Type", "application/json");

            // const raw = JSON.stringify({
            //     "userId": selectedUserId,
            //     "password": values.iv_new_password,
            //     "remarks": values.iv_remarks,
            // });

            // const requestOptions = {
            //     method: "POST",
            //     headers: myHeaders,
            //     body: raw,
            //     redirect: "follow"
            // };

            // await fetch(cfpBaseUrl + "customerFaciliationPortal/changePasswordofUser", requestOptions)
            //     .then((response) => response.json())
            //     .then((result) => {
            //         if (result.status === "200") {
            //             resetForm();
            //             setShowChangePasswordPopup(false)
            //             setShowSuccessSnackbar(true);
            //             setTimeout(() => {
            //                 setShowChangePasswordPopup(false);
            //             }, 300);
            //         } else if (result.status === "400") {
            //             setApiError(result.message)
            //         }
            //     })
            //     .catch((error) => console.error(error));
            // setViewBackdrop(false);
            setViewBackdrop(true);
            const myHeaders = new Headers();
            myHeaders.append("Authorization", token);
            myHeaders.append("Content-Type", "application/json");

            const raw = JSON.stringify({
                "divisionCode": selectedUserId,
                "divisionERPCode": values.iv_divisionERPCode,
                "divBankName": values.iv_divBankName,
                "divCapitalCostAccountNo": values.iv_divCapitalCostAccountNo,
                "divSecurityAccountNo": values.iv_divSecurityAccountNo,
                "remarks": values.iv_remarks
            });

            const requestOptions = {
                method: "PUT",
                headers: myHeaders,
                body: raw,
                redirect: "follow"
            };

            await fetch(cfpBaseUrl + "customerFaciliationPortal/updateDivisionBankDetails", requestOptions)
                .then((response) => response.json())
                .then((result) => {
                    if (result.status === "200") {
                        resetForm();
                        setShowChangePasswordPopup(false)
                        setShowSuccessSnackbar(true);
                        window.location.reload()
                        setTimeout(() => {
                            setShowChangePasswordPopup(false);
                        }, 300);
                    } else if (result.status === "400") {
                        setApiError(result.message)
                    }
                }
                )
                .catch((error) => console.error(error));
            setViewBackdrop(false);
        },
    });
    const filterDivision = (divisionCode) => {
        let itemFound = tableDivision.find(item => item.divisionCode === divisionCode)
        return itemFound;
    }

    const handleClose = () => {
        setOpen(false);
    };

    const handleClose2 = () => {
        setopen2(false);
    };

    const onDelete = async () => {
        var formdata = new FormData();
        formdata.append("divisionCode", dltDivision);
        const myHeaders = new Headers();
        myHeaders.append("Authorization", token);

        var requestOptions = {
            method: 'POST',
            body: formdata,
            headers: myHeaders,
            redirect: 'follow',
        };

        await fetch(cfpBaseUrl + "customerFaciliationPortal/deleteDivision", requestOptions)
            .then(response => response.json())
            .then(result => {
                if (result.status === '200') {
                    let myArray = [...tableDivision]
                    let index = myArray.findIndex(obj => obj.divisionCode == dltDivision);
                    if (index != -1) {
                        myArray.splice(index, 1);
                        setTableDivision(myArray)
                    }
                }
                else {
                }
            })
            .catch(error => console.log('error', error));
        handleClose2();
    }

    // const tblColumns = [
    //     { field: "id", headerName: 'Code', align: 'center', headerStyle: tableStyle.headerStyle, headerCellStyle: tableStyle.headerCellStyle, rowCellStyle: tableStyle.rowCellStyle },
    //     { field: "completename", headerName: 'Division Name', align: 'center', headerStyle: tableStyle.headerStyle, headerCellStyle: tableStyle.headerCellStyle, rowCellStyle: tableStyle.rowCellStyle },
    //     { field: "circlename", headerName: 'Circle Code', align: 'center', headerStyle: tableStyle.headerStyle, headerCellStyle: tableStyle.headerCellStyle, rowCellStyle: tableStyle.rowCellStyle },
    //     { field: "companyname", headerName: 'Company Name', align: 'center', headerStyle: tableStyle.headerStyle, headerCellStyle: tableStyle.headerCellStyle, rowCellStyle: tableStyle.rowCellStyle },
    //     {
    //         field: "button", headerName: 'Bank Details ', align: 'center', headerStyle: tableStyle.headerStyle, headerCellStyle: tableStyle.headerCellStyle, rowCellStyle: tableStyle.rowCellStyle,
    //         renderCell: (params) => {
    //             return (
    //                 <div style={{ width: '100%', display: 'flex', justifyContent: 'center' }}>
    //                     <IconButton aria-label="delete" size="small" sx={{ margin: 0.4, padding: 0 }}>
    //                         <EditNoteIcon sx={{ color: '#e25316ff' }}
    //                             onClick={() => {
    //                                 setSelectedUserId(params.id);
    //                                 setShowChangePasswordPopup(true);
    //                             }}
    //                             alt="Bank Details" style={{ width: '24px', height: '24px' }} />
    //                     </IconButton>
    //                 </div>
    //             )
    //         }
    //     },
    //     {
    //         headerName: "Action",
    //         sortable: false,
    //         field: 'buttons',
    //         align: 'center',
    //         headerStyle: tableStyle.headerStyle,
    //         headerCellStyle: tableStyle.headerCellStyle,
    //         rowCellStyle: tableStyle.rowCellStyle,
    //         renderCell: (params) => {

    //             const onViewDivision = (e) => {
    //                 e.stopPropagation(); // don't select this row after clicking
    //                 const item = filterDivision(params.id);
    //                 setDialogRowData(item);
    //                 setOpen(true);
    //             };

    //             const onDeleteDivision = (e) => {
    //                 e.stopPropagation(); // don't select this row after clicking
    //                 setopen2(true);
    //                 setDltDivision(params.id)
    //             }

    //             const onEditDivision = (e) => {
    //                 e.stopPropagation(); // don't select this row after clicking
    //                 const divisionToEdit = filterDivision(params.id);
    //                 Navigate('/division-management/update-division', { state: { divisionToEdit } })
    //             }

    //             return (
    //                 <>
    //                     <Box>
    //                         <Box>
    //                             {
    //                                 CheckPermissions(permissions, 'Organization Management', 'Division Management', 'Read') ?
    //                                     <IconButton onClick={onViewDivision} aria-label="delete" size="small" sx={{ margin: 0.4, padding: 0 }}>
    //                                         <VisibilityIcon sx={{ color: 'skyblue' }} fontSize='inherit' />
    //                                     </IconButton> : null
    //                             }
    //                             {
    //                                 CheckPermissions(permissions, 'Organization Management', 'Division Management', 'Update') ?
    //                                     <IconButton onClick={onEditDivision} aria-label="delete" size="small" sx={{ margin: 0.4, padding: 0 }}>
    //                                         <EditIcon fontSize="inherit" sx={{ color: 'blue' }} />
    //                                     </IconButton> : null
    //                             }
    //                             {
    //                                 CheckPermissions(permissions, 'Organization Management', 'Division Management', 'Delete') ?
    //                                     <IconButton aria-label="delete" size="small" sx={{ margin: 0, padding: 0 }} onClick={onDeleteDivision}>
    //                                         <DeleteIcon fontSize="inherit" sx={{ color: 'red' }} />
    //                                     </IconButton> : null
    //                             }
    //                         </Box>
    //                     </Box>
    //                 </>
    //             )
    //         }
    //     }
    // ]
    const tblColumns = [
        { field: "id", headerName: 'Code', align: 'center', headerStyle: tableStyle.headerStyle, headerCellStyle: tableStyle.headerCellStyle, rowCellStyle: tableStyle.rowCellStyle },
        { field: "completename", headerName: 'Division Name', align: 'center', headerStyle: tableStyle.headerStyle, headerCellStyle: tableStyle.headerCellStyle, rowCellStyle: tableStyle.rowCellStyle },
        { field: "circlename", headerName: 'Circle Code', align: 'center', headerStyle: tableStyle.headerStyle, headerCellStyle: tableStyle.headerCellStyle, rowCellStyle: tableStyle.rowCellStyle },
        { field: "companyname", headerName: 'Company Name', align: 'center', headerStyle: tableStyle.headerStyle, headerCellStyle: tableStyle.headerCellStyle, rowCellStyle: tableStyle.rowCellStyle },

        // ✅ Show only if user has permission
        CheckPermissions(permissions, "Organization Management", "Division Management", "Update Div Bank Details") && {
            field: "button",
            headerName: "Bank Details",
            align: "center",
            headerStyle: tableStyle.headerStyle,
            headerCellStyle: tableStyle.headerCellStyle,
            rowCellStyle: tableStyle.rowCellStyle,
            renderCell: (params) => (
                <div style={{ width: "100%", display: "flex", justifyContent: "center" }}>
                    <IconButton aria-label="edit" size="small" sx={{ margin: 0.4, padding: 0 }}>
                        <EditNoteIcon
                            sx={{ color: "#e25316ff" }}
                            onClick={() => {
                                setSelectedUserId(params.id);
                                bankdetailsFormik.setValues({
                                    iv_divisionERPCode: params ? params.erp_code || "" : "",
                                    iv_divBankName: params ? params.bank_name || "" : "",
                                    iv_divCapitalCostAccountNo: params ? params.capital_code || "" : "",
                                    iv_divSecurityAccountNo: params ? params.security_code || "" : "",
                                    iv_remarks: "",
                                });
                                setShowChangePasswordPopup(true);
                            }}
                            alt="Bank Details"
                            style={{ width: "24px", height: "24px" }}
                        />
                    </IconButton>
                </div>
            ),
        },

        {
            headerName: "Action",
            sortable: false,
            field: "buttons",
            align: "center",
            headerStyle: tableStyle.headerStyle,
            headerCellStyle: tableStyle.headerCellStyle,
            rowCellStyle: tableStyle.rowCellStyle,
            renderCell: (params) => {
                const onViewDivision = (e) => {
                    e.stopPropagation();
                    const item = filterDivision(params.id);
                    setDialogRowData(item);
                    setOpen(true);
                };

                const onDeleteDivision = (e) => {
                    e.stopPropagation();
                    setopen2(true);
                    setDltDivision(params.id);
                };

                const onEditDivision = (e) => {
                    e.stopPropagation();
                    const divisionToEdit = filterDivision(params.id);
                    Navigate("/division-management/update-division", {
                        state: { divisionToEdit },
                    });
                };

                return (
                    <Box>
                        {CheckPermissions(permissions, "Organization Management", "Division Management", "Read") && (
                            <IconButton onClick={onViewDivision} size="small" sx={{ margin: 0.4, padding: 0 }}>
                                <VisibilityIcon sx={{ color: "skyblue" }} fontSize="inherit" />
                            </IconButton>
                        )}
                        {CheckPermissions(permissions, "Organization Management", "Division Management", "Update") && (
                            <IconButton onClick={onEditDivision} size="small" sx={{ margin: 0.4, padding: 0 }}>
                                <EditIcon fontSize="inherit" sx={{ color: "blue" }} />
                            </IconButton>
                        )}
                        {CheckPermissions(permissions, "Organization Management", "Division Management", "Delete") && (
                            <IconButton onClick={onDeleteDivision} size="small" sx={{ margin: 0, padding: 0 }}>
                                <DeleteIcon fontSize="inherit" sx={{ color: "red" }} />
                            </IconButton>
                        )}
                    </Box>
                );
            },
        },
    ].filter(Boolean); // ✅ removes `false` entries

    const apiToDataGridConversion = () => {
        const myArray = tableDivision
        const tempArray = []
        if (myArray) {
            myArray.forEach((item) => {
                console.log(item, 'print item')
                const slicedCircleCode = item.circleCode.toString().slice(0, 2);

                console.log(slicedCircleCode, 'circle code')
                const dataGridObject = {
                    "id": item.divisionCode,
                    "completename": item.divisionName ? item.divisionName : '-',
                    // "created_by": item.createdBy ? item.createdBy : '-',
                    // "created_at": item.createdDate ? convertDate(item.createdDate) : '-',
                    // "updated_by": item.updateBy ? item.updateBy : '-',
                    // "updated_at": item.updatedDate ? convertDate(item.updatedDate) : '-',
                    "circlename": item.circleCode ? item.circleCode : "-",
                    "companyname": companyShortName(slicedCircleCode),
                    "bank_name": item.divBankName ? item.divBankName : '-',
                    "erp_code": item.divErpCode ? item.divErpCode : '-',
                    "capital_code": item.divCapitalCostAccountNo ? item.divCapitalCostAccountNo : '-',
                    "security_code": item.divSecurityAccountNo ? item.divSecurityAccountNo : '-'
                }
                tempArray.push(dataGridObject)
            })
        }
        else {
            const dataGridObject = {
                "id": " ",
                "completename": " ",
                "created_by": " ",
                "created_at": " ",
                "updated_by": " ",
                "updated_at": " ",
            }
            tempArray.push(dataGridObject)
        }
        setDivisionsToDataGrid(tempArray);
        setFilteredData(tempArray); // keep a filtered copy
    }
    const handleSearch = (event) => {
        const value = event.target.value.toLowerCase();
        setSearchQuery(value);

        const filtered = divisionsToDataGrid.filter((row) =>
            row.id.toString().toLowerCase().includes(value) ||
        row.completename.toString().toLowerCase().includes(value) ||
        row.circlename.toString().toLowerCase().includes(value) ||
        row.companyname.toString().toLowerCase().includes(value) 
        );

        setFilteredData(filtered);
    };
    return (
        <>
            <Box className='form-box'>
                {/* <Box className='main-heading'>
                    <h2>
                        Division Management
                    </h2>
                    <div className='btn2'>
                        {
                            CheckPermissions(permissions,'Organization Management', 'Division Management', 'Create') &&
                            < Link to="/division-management/new-division">
                                <Button variant="contained" size='small' className='btnNewApplication' startIcon={<AddCircleIcon />} sx={{ textTransform: 'capitalize' }} >
                                    Create Division
                                </Button>
                            </Link>
                        }
                    </div>
                </Box> */}
                <Box display="flex" justifyContent="space-between" alignItems="center" mb={2}>
                    <h3 className="page-title">Division Management</h3>

                    <div
                        style={{
                            backgroundColor: "white",
                            display: "flex",
                            alignItems: "center",
                            borderRadius: "10px",
                            padding: "5px 10px",
                            border: "1px solid grey",
                            margin: "0px", 
                        }}
                    >
                        <input
                            type="text"
                            value={searchQuery}
                            onChange={handleSearch}
                            placeholder="Search by Code, Division/Company Name or Circle Code"
                            maxLength={20}
                            style={{
                                flex: 1,
                                padding: "8px",
                                border: "none",
                                backgroundColor: "transparent", 
                                outline: "none",
                                fontSize: "13px",
                                minWidth: "300px",
                            }}
                        />
                        <SearchIcon
                            sx={{
                                color: "#09669d",
                                width: 30,
                                height: 30,
                                borderRadius: "8px",
                                padding: "6px",
                                cursor: "pointer",
                                transition: "background-color 0.3s",
                                "&:hover": {
                                    color: "#074f7d",
                                },
                            }}
                        />
                    </div>
                </Box>
                <Box sx={{ maxHeight: '100%', overflow: 'auto' }} className='application-table'>
                    <BasicTable
                        data={filteredData}
                        columns={tblColumns}
                        sx={tableStyle}
                        rowHeight={37.5}
                        pageSize={18}
                        rowsPerPageOptions={[18, 30, 60]}
                        rowsPageOption={false}
                        getRowStyle={(params) => {
                            return params.indexRelativeToCurrentPage % 2 === 0
                                ? tableStyle.evenRow
                                : tableStyle.oddRow;
                        }}
                    />
                </Box>

            </Box>

            {/* <Dialog
                open={open}
                onClose={handleClose}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
                PaperProps={{ sx: { width: '30%' } }}
            >
                <DialogTitle id="alert-dialog-title" className="dialog-title">
                    <IconButton onClick={handleClose} sx={{ position: "relative", float: 'right' }}>
                        <CloseIcon />
                    </IconButton>
                    <Typography sx={{ fontWeight: 'bold' }}>Division Details</Typography>
                </DialogTitle>
                <DialogContent className='dialog-content'>
                    <DialogContentText id="alert-dialog-description">
                        <hr />
                        <Grid className='content-grid' sx={{ mt: '17px', display: 'flex', flexDirection: "column" }}>
                            <Box sx={{ display: 'flex', flexDirection: 'column' }}>
                                <Box sx={{ display: 'flex', flexDirection: 'row', justifyContent: "space-between" }}>
                                    <h5>ID:</h5><span>{dialogRowData.divisionCode ? dialogRowData.divisionCode : '-'}</span>
                                </Box>
                                <Box sx={{ display: 'flex', flexDirection: 'row', justifyContent: "space-between" }}>
                                    <h5>Name:</h5><p>{dialogRowData.divisionName ? dialogRowData.divisionName : '-'}</p>
                                </Box>
                                <Box sx={{ display: 'flex', flexDirection: 'row', justifyContent: "space-between" }}>
                                    <h5>Latitude:</h5><p>{dialogRowData.latitude ? dialogRowData.latitude : '-'}</p>
                                </Box>
                                <Box sx={{ display: 'flex', flexDirection: 'row', justifyContent: "space-between" }}>
                                    <h5>Longitude:</h5><p>{dialogRowData.longitude ? dialogRowData.longitude : '-'}</p>
                                </Box>
                                <Box sx={{ display: 'flex', flexDirection: 'row', justifyContent: "space-between" }}>
                                    <h5>status:</h5><p>{(dialogRowData.status === '0' || dialogRowData.status === 'active') ? 'Active' : 'InActive'}</p>
                                </Box>
                                <Box sx={{ display: 'flex', flexDirection: 'row', justifyContent: "space-between" }}>
                                    <h5 >Created by:</h5><p>{dialogRowData.createdBy ? dialogRowData.createdBy : '-'}</p>
                                </Box>
                                <Box sx={{ display: 'flex', flexDirection: 'row', justifyContent: "space-between" }}>
                                    <h5 >Created at:</h5><p>{dialogRowData.createdDate ? convertDatewithTime(dialogRowData.createdDate) : '-'}</p>
                                </Box>
                                <Box sx={{ display: 'flex', flexDirection: 'row', justifyContent: "space-between" }}>
                                    <h5 >Last Updated By:</h5><p>{dialogRowData.updateBy ? dialogRowData.updateBy : '-'}</p>
                                </Box>
                                <Box sx={{ display: 'flex', flexDirection: 'row', justifyContent: "space-between" }}>
                                    <h5 >Last Updated At:</h5><p>{dialogRowData.updatedDate ? convertDatewithTime(dialogRowData.updatedDate) : '-'}</p>
                                </Box>
                                <Box sx={{ marginTop: '35px' }}>
                                    <Typography sx={{ fontWeight: 'bold' }}>Contact Person 1</Typography>
                                </Box>
                                <hr />
                                <Box sx={{ display: 'flex', flexDirection: 'row', justifyContent: "space-between" }}>
                                    <h5 >Name:</h5><p>{dialogRowData.cp1Name ? dialogRowData.cp1Name : '-'}</p>
                                </Box>
                                <Box sx={{ display: 'flex', flexDirection: 'row', justifyContent: "space-between" }}>
                                    <h5 >Phone:</h5><p>{dialogRowData.cp1phone ? dialogRowData.cp1phone : '-'}</p>
                                </Box>
                                <Box sx={{ display: 'flex', flexDirection: 'row', justifyContent: "space-between" }}>
                                    <h5 >Mobile:</h5><p>{dialogRowData.cp1Mobile ? dialogRowData.cp1Mobile : '-'}</p>
                                </Box>
                                <Box sx={{ display: 'flex', flexDirection: 'row', justifyContent: "space-between" }}>
                                    <h5 >Email:</h5><p>{dialogRowData.cp1Email ? dialogRowData.cp1Email : '-'}</p>
                                </Box>
                                <Box sx={{ marginTop: '35px' }}>
                                    <Typography sx={{ fontWeight: 'bold' }}>Contact Person 2</Typography>
                                </Box>
                                <hr />
                                <Box sx={{ display: 'flex', flexDirection: 'row', justifyContent: "space-between" }}>
                                    <h5 >Name:</h5><p>{dialogRowData.cp2Name ? dialogRowData.cp2Name : '-'}</p>
                                </Box>
                                <Box sx={{ display: 'flex', flexDirection: 'row', justifyContent: "space-between" }}>
                                    <h5 >Phone:</h5><p>{dialogRowData.cp2phone ? dialogRowData.cp2phone : '-'}</p>
                                </Box>
                                <Box sx={{ display: 'flex', flexDirection: 'row', justifyContent: "space-between" }}>
                                    <h5 >Mobile:</h5><p>{dialogRowData.cp2Mobile ? dialogRowData.cp2Mobile : '-'}</p>
                                </Box>
                                <Box sx={{ display: 'flex', flexDirection: 'row', justifyContent: "space-between" }}>
                                    <h5 >Email:</h5><p>{dialogRowData.cp2Email ? dialogRowData.cp2Email : '-'}</p>
                                </Box>
                                <Box sx={{ marginTop: '35px' }}>
                                    <Typography sx={{ fontWeight: 'bold' }}>Bank Details</Typography>
                                </Box>
                                <hr />
                                <Box sx={{ display: 'flex', flexDirection: 'row', justifyContent: "space-between" }}>
                                    <h5 >Bank Name:</h5><p>{dialogRowData.divBankName ? dialogRowData.divBankName : '-'}</p>
                                </Box>
                                <Box sx={{ display: 'flex', flexDirection: 'row', justifyContent: "space-between" }}>
                                    <h5 >ERP Code:</h5><p>{dialogRowData.divErpCode ? dialogRowData.divErpCode : '-'}</p>
                                </Box>
                                <Box sx={{ display: 'flex', flexDirection: 'row', justifyContent: "space-between" }}>
                                    <h5 >Capital Cost Account No.:</h5><p>{dialogRowData.divCapitalCostAccountNo ? dialogRowData.divCapitalCostAccountNo : '-'}</p>
                                </Box>
                                <Box sx={{ display: 'flex', flexDirection: 'row', justifyContent: "space-between" }}>
                                    <h5 >Security Cost Account No.:</h5><p>{dialogRowData.divSecurityAccountNo ? dialogRowData.divSecurityAccountNo : '-'}</p>
                                </Box>
                            </Box>
                        </Grid>
                    </DialogContentText>
                </DialogContent>
            </Dialog > */}
            <Dialog
                open={open}
                onClose={handleClose}
                fullWidth
                maxWidth="md"
                PaperProps={{ sx: { borderRadius: 3, maxWidth: 1000 } }}
                className="alert-popups"
            >
                <DialogTitle
                    sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}
                    className="dialog-title"
                >
                    Division Details
                    <IconButton onClick={handleClose} sx={{ color: 'black' }}>
                        <CloseIcon />
                    </IconButton>
                </DialogTitle>

                <DialogContent className="dialog-content">
                    <DialogContentText sx={{ minHeight: 300 }}>
                        <Grid container spacing={2} sx={{ padding: '20px' }}>
                            {/* Section Header */}
                            <Grid item xs={12}>
                                <Box sx={{ backgroundColor: '#d5e5ff', padding: '5px' }}>
                                    <h4 style={{ color: '#006ad1' }}>General Information</h4>
                                </Box>
                            </Grid>

                            {/* Division Info */}
                            {[
                                { label: 'ID', value: dialogRowData.divisionCode },
                                { label: 'Name', value: dialogRowData.divisionName },
                                { label: 'Latitude', value: dialogRowData.latitude },
                                { label: 'Longitude', value: dialogRowData.longitude },
                                {
                                    label: 'Status',
                                    value:
                                        dialogRowData.status === '0' || dialogRowData.status === 'active'
                                            ? 'Active'
                                            : 'Inactive',
                                },
                                { label: 'Created By', value: dialogRowData.createdBy },
                                {
                                    label: 'Created At',
                                    value: convertDatewithTime(dialogRowData.createdDate),
                                },
                                { label: 'Last Updated By', value: dialogRowData.updateBy },
                                {
                                    label: 'Last Updated At',
                                    value: convertDatewithTime(dialogRowData.updatedDate),
                                },
                            ].map((item, index) => (
                                <Grid item xs={12} sm={6} md={4} key={index}>
                                    <label style={{ fontWeight: 600 }}>{item.label}</label>
                                    <TextField
                                        value={item.value || '-'}
                                        fullWidth
                                        disabled
                                        size="small"
                                        sx={{ mt: 0.5 }}
                                    />
                                </Grid>
                            ))}

                            {/* Contact Person 1 */}
                            <Grid item xs={12} mt={3}>
                                <Box sx={{ backgroundColor: '#d5e5ff', padding: '5px' }}>
                                    <h4 style={{ color: '#006ad1' }}>Contact Person 1</h4>
                                </Box>
                            </Grid>
                            {[
                                { label: 'Name', value: dialogRowData.cp1Name },
                                { label: 'Phone', value: dialogRowData.cp1phone },
                                { label: 'Mobile', value: dialogRowData.cp1Mobile },
                                { label: 'Email', value: dialogRowData.cp1Email },
                            ].map((item, index) => (
                                <Grid item xs={12} sm={6} md={4} key={`cp1-${index}`}>
                                    <label style={{ fontWeight: 600 }}>{item.label}</label>
                                    <TextField
                                        value={item.value || '-'}
                                        fullWidth
                                        disabled
                                        size="small"
                                        sx={{ mt: 0.5 }}
                                    />
                                </Grid>
                            ))}

                            {/* Contact Person 2 */}
                            <Grid item xs={12} mt={3}>
                                <Box sx={{ backgroundColor: '#d5e5ff', padding: '5px' }}>
                                    <h4 style={{ color: '#006ad1' }}>Contact Person 2</h4>
                                </Box>
                            </Grid>
                            {[
                                { label: 'Name', value: dialogRowData.cp2Name },
                                { label: 'Phone', value: dialogRowData.cp2phone },
                                { label: 'Mobile', value: dialogRowData.cp2Mobile },
                                { label: 'Email', value: dialogRowData.cp2Email },
                            ].map((item, index) => (
                                <Grid item xs={12} sm={6} md={4} key={`cp2-${index}`}>
                                    <label style={{ fontWeight: 600 }}>{item.label}</label>
                                    <TextField
                                        value={item.value || '-'}
                                        fullWidth
                                        disabled
                                        size="small"
                                        sx={{ mt: 0.5 }}
                                    />
                                </Grid>
                            ))}

                            {/* Bank Details */}
                            <Grid item xs={12} mt={3}>
                                <Box sx={{ backgroundColor: '#d5e5ff', padding: '5px' }}>
                                    <h4 style={{ color: '#006ad1' }}>Bank Details</h4>
                                </Box>
                            </Grid>
                            {[
                                { label: 'Bank Name', value: dialogRowData.divBankName },
                                { label: 'ERP Code', value: dialogRowData.divErpCode },
                                {
                                    label: 'Capital Cost Account No.',
                                    value: dialogRowData.divCapitalCostAccountNo,
                                },
                                {
                                    label: 'Security Cost Account No.',
                                    value: dialogRowData.divSecurityAccountNo,
                                },
                            ].map((item, index) => (
                                <Grid item xs={12} sm={6} md={4} key={`bank-${index}`}>
                                    <label style={{ fontWeight: 600 }}>{item.label}</label>
                                    <TextField
                                        value={item.value || '-'}
                                        fullWidth
                                        disabled
                                        size="small"
                                        sx={{ mt: 0.5 }}
                                    />
                                </Grid>
                            ))}
                        </Grid>
                    </DialogContentText>
                </DialogContent>
            </Dialog>


            <Dialog
                open={open2}
                onClose={handleClose2}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
            >
                <DialogTitle id="alert-dialog-title">
                    {" Are you sure to delete this record"}
                </DialogTitle>
                <DialogActions>
                    <Button onClick={handleClose2}>Cancel</Button>
                    <Button onClick={onDelete} autoFocus>
                        Confirm
                    </Button>
                </DialogActions>
            </Dialog>

            < Dialog
                open={showChangePasswordPopup}
                onClose={() => (setShowChangePasswordPopup(false), setSelectedUserId(null), bankdetailsFormik.values.iv_divBankName = '', bankdetailsFormik.values.iv_divCapitalCostAccountNo = '', bankdetailsFormik.values.iv_remarks = '', bankdetailsFormik.values.iv_divSecurityAccountNo = '', bankdetailsFormik.values.iv_divisionERPCode = '')}
                fullWidth={true}
                maxWidth="xs"
                className='alert-popups' >
                <DialogTitle sx={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between' }} className='dialog-title'>
                    Division Bank Details
                    <Box sx={{ marginTop: '1%' }} >
                        <CloseIcon id="clearPopup" onClick={() => (setShowChangePasswordPopup(false), setSelectedUserId(null), bankdetailsFormik.values.iv_divBankName = '', bankdetailsFormik.values.iv_divCapitalCostAccountNo = '', bankdetailsFormik.values.iv_remarks = '', bankdetailsFormik.values.iv_divSecurityAccountNo = '', bankdetailsFormik.values.iv_divisionERPCode = '')} sx={{ color: 'white', cursor: 'pointer' }} />
                    </Box>
                </DialogTitle>
                <DialogContent className='dialog-content'>
                    <DialogContentText>
                        <form className='complaintform'>
                            <Grid container sx={{ padding: '20px' }}>
                                <Grid item lg={12} >
                                    <Grid container spacing={1}>
                                        <Grid item lg={12}>
                                            <Grid container spacing={1}>

                                                <Grid item lg={12}>
                                                    <label>Division Code</label>
                                                    <TextField
                                                        sx={{
                                                            width: '100%',
                                                            '.MuiInputBase-input': {
                                                                height: '.5vh',
                                                            },
                                                        }}
                                                        required
                                                        type="text"
                                                        autoComplete="off"
                                                        name="iv_remarks"
                                                        value={selectedUserId}
                                                        disabled
                                                        id="iv_remarks"
                                                        className="textInputField"
                                                    />

                                                </Grid>
                                                <Grid item lg={12}>
                                                    <label>ERP Code</label>
                                                    <TextField
                                                        sx={{
                                                            width: '100%',
                                                            '.MuiInputBase-input': {
                                                                height: '.5vh',
                                                            },
                                                        }}
                                                        required
                                                        type="text"
                                                        autoComplete="off"
                                                        name="iv_divisionERPCode"
                                                        value={bankdetailsFormik.values.iv_divisionERPCode}
                                                        onChange={bankdetailsFormik.handleChange}
                                                        onBlur={bankdetailsFormik.handleBlur}
                                                        id="iv_divisionERPCode"
                                                        className="textInputField"
                                                    />
                                                    <Grid>
                                                        {
                                                            bankdetailsFormik.errors.iv_divisionERPCode && bankdetailsFormik.touched.iv_divisionERPCode ? (
                                                                <p style={{ color: '#f73232', fontSize: '1rem' }}>{bankdetailsFormik.errors.iv_divisionERPCode}</p>
                                                            ) : null
                                                        }
                                                    </Grid>
                                                </Grid>
                                                <Grid item lg={12}>
                                                    <label>Bank Name</label>
                                                    <TextField
                                                        sx={{
                                                            width: '100%',
                                                            '.MuiInputBase-input': {
                                                                height: '.5vh',
                                                            },
                                                        }}
                                                        required
                                                        type="text"
                                                        autoComplete="off"
                                                        name="iv_divBankName"
                                                        value={bankdetailsFormik.values.iv_divBankName}
                                                        onChange={bankdetailsFormik.handleChange}
                                                        onBlur={bankdetailsFormik.handleBlur}
                                                        id="iv_divBankName"
                                                        className="textInputField"
                                                    />
                                                    <Grid>
                                                        {
                                                            bankdetailsFormik.errors.iv_divBankName && bankdetailsFormik.touched.iv_divBankName ? (
                                                                <p style={{ color: '#f73232', fontSize: '1rem' }}>{bankdetailsFormik.errors.iv_divBankName}</p>
                                                            ) : null
                                                        }
                                                    </Grid>
                                                </Grid>
                                                <Grid item lg={12}>
                                                    <label>Capital Cost Account No.</label>
                                                    <TextField
                                                        sx={{
                                                            width: '100%',
                                                            '.MuiInputBase-input': {
                                                                height: '.5vh',
                                                            },
                                                        }}
                                                        required
                                                        type="text"
                                                        autoComplete="off"
                                                        name="iv_divCapitalCostAccountNo"
                                                        value={bankdetailsFormik.values.iv_divCapitalCostAccountNo}
                                                        onChange={bankdetailsFormik.handleChange}
                                                        onBlur={bankdetailsFormik.handleBlur}
                                                        id="iv_divCapitalCostAccountNo"
                                                        className="textInputField"
                                                    />
                                                    <Grid>
                                                        {
                                                            bankdetailsFormik.errors.iv_divCapitalCostAccountNo && bankdetailsFormik.touched.iv_divCapitalCostAccountNo ? (
                                                                <p style={{ color: '#f73232', fontSize: '1rem' }}>{bankdetailsFormik.errors.iv_divCapitalCostAccountNo}</p>
                                                            ) : null
                                                        }
                                                    </Grid>
                                                </Grid>
                                                <Grid item lg={12}>
                                                    <label>Security Account No</label>
                                                    <TextField
                                                        sx={{
                                                            width: '100%',
                                                            '.MuiInputBase-input': {
                                                                height: '.5vh',
                                                            },
                                                        }}
                                                        required
                                                        type="text"
                                                        autoComplete="off"
                                                        name="iv_divSecurityAccountNo"
                                                        value={bankdetailsFormik.values.iv_divSecurityAccountNo}
                                                        onChange={bankdetailsFormik.handleChange}
                                                        onBlur={bankdetailsFormik.handleBlur}
                                                        id="iv_divSecurityAccountNo"
                                                        className="textInputField"
                                                    />
                                                    <Grid>
                                                        {
                                                            bankdetailsFormik.errors.iv_divSecurityAccountNo && bankdetailsFormik.touched.iv_divSecurityAccountNo ? (
                                                                <p style={{ color: '#f73232', fontSize: '1rem' }}>{bankdetailsFormik.errors.iv_divSecurityAccountNo}</p>
                                                            ) : null
                                                        }
                                                    </Grid>
                                                </Grid>
                                                <Grid item lg={12}>
                                                    <label>Remarks</label>
                                                    <TextField
                                                        sx={{
                                                            width: '100%',
                                                            '.MuiInputBase-input': {
                                                                height: '.5vh',
                                                            },
                                                        }}
                                                        required
                                                        type="text"
                                                        autoComplete="off"
                                                        name="iv_remarks"
                                                        value={bankdetailsFormik.values.iv_remarks}
                                                        onChange={bankdetailsFormik.handleChange}
                                                        onBlur={bankdetailsFormik.handleBlur}
                                                        id="iv_remarks"
                                                        className="textInputField"
                                                    />
                                                    <Grid>
                                                        {
                                                            bankdetailsFormik.errors.iv_remarks && bankdetailsFormik.touched.iv_remarks ? (
                                                                <p style={{ color: '#f73232', fontSize: '1rem' }}>{bankdetailsFormik.errors.iv_remarks}</p>
                                                            ) : null
                                                        }
                                                    </Grid>
                                                </Grid>

                                                <Grid item lg={12} >
                                                    {
                                                        apiError &&
                                                        <Error
                                                            error={apiError}
                                                            onClose={() => errorCloses()}
                                                            backgroundColor="#FFC0CB"
                                                            textColor="#bb0303"
                                                            iconColor="#bb0303"
                                                        />
                                                    }
                                                </Grid>
                                                <Grid item lg={12} sx={{ display: 'flex', justifyContent: 'flex-end' }}>
                                                    <Button sx={{ width: '30%' }} variant="contained" size="medium" onClick={bankdetailsFormik.handleSubmit}>
                                                        Submit
                                                    </Button>
                                                </Grid>
                                            </Grid>
                                        </Grid>
                                    </Grid>
                                </Grid>
                            </Grid>
                        </form>
                    </DialogContentText>
                </DialogContent>
            </Dialog >
            <Snackbar
                open={showSuccessSnackbar}
                autoHideDuration={3000}
                onClose={() => setShowSuccessSnackbar(false)}
                anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
                sx={{
                    position: "fixed",
                    top: "50%",
                    left: "50%",
                    transform: "translate(-50%, -50%)",
                }}
            >
                <Alert
                    onClose={() => setShowSuccessSnackbar(false)}
                    severity="success"
                    sx={{ width: '100%' }}
                >
                    Bank Details Saved.
                </Alert>
            </Snackbar>

            {/* Backdrop */}
            < Backdrop
                sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1000 }}
                open={viewBackdrop}
            >
                <CircularProgress color="inherit" />
            </Backdrop >
        </>
    )
}
